import { render, staticRenderFns } from "./VolunteerProgress.vue?vue&type=template&id=30ace963&scoped=true"
import script from "./VolunteerProgress.vue?vue&type=script&lang=js"
export * from "./VolunteerProgress.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProgress.vue?vue&type=style&index=0&id=30ace963&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ace963",
  null
  
)

export default component.exports